<template>
  <el-container v-title data-title="订单记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>订单统计</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <!-- <el-option label="全部" value=""></el-option> -->
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="getOrderStatsList">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="isDownloading" @click="downloadOrderStatsList">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="220"></el-table-column>
          <el-table-column prop="className" label="班级" width="90"></el-table-column>
          <el-table-column prop="realName" label="学生姓名" width="90"></el-table-column>
          <el-table-column prop="studentTypeName" label="学生类型" width="90"></el-table-column>
          <el-table-column prop="cardNo1" label="卡号1" width="120"></el-table-column>
          <el-table-column prop="cardNo2" label="卡号2" width="120"></el-table-column>
          <el-table-column prop="yearFeePaid" label="已缴年费" width="100"></el-table-column>
          <el-table-column prop="yearFeePaidTime" label="已缴年费时间" width="170"></el-table-column>
          <el-table-column prop="yearFeeRefund" label="已退年费" width="100"></el-table-column>
          <el-table-column prop="yearFeeRefundTime" label="已退年费时间" width="170"></el-table-column>
          <el-table-column prop="regainCardPaid" label="已缴补卡" width="100"></el-table-column>
          <el-table-column prop="regainCardPaidTime" label="已缴补卡时间" width="170"></el-table-column>
          <el-table-column prop="regainCardRefund" label="已退补卡" width="100"></el-table-column>
          <el-table-column prop="regainCardRefundTime" label="已退补卡时间" width="170"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getOrderStatsList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      isDownloading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        'schoolId': ''
      },
      schoolList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getOrderStatsList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getOrderStatsList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/order/statsList',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    // formatYuan: function (row, column) {
    //   if (row != null && column.property != null) {
    //     switch (column.property) {
    //       case 'yearFeePaid':
    //         return row.yearFeePaid / 100
    //       case 'yearFeeRefund':
    //         return row.yearFeeRefund / 100
    //       case 'regainCardPaid':
    //         return row.regainCardPaid / 100
    //       case 'regainCardRefund':
    //         return row.regainCardRefund / 100
    //     }
    //   }
    //   return '0'
    // },
    downloadOrderStatsList () {
      if (this.month === '') return
      let _this = this
      _this.isDownloading = true
      this.$axios.post(this.GLOBAL.host + '/order/downloadStatsList', this.$qs.stringify({
        schoolId: _this.searchForm.schoolId
      }), {
        responseType: 'blob'
      }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StatsForOrder.vue